import { CSRF, getData, getElement } from "../../../../helpers";
import { Dt } from "../../../../plugins/datatable";
import { TaxModal } from "./modals/store";

class TaxModule extends HTMLElement {
    connectedCallback() {
        this.load();
        this.events();
    }

    load() {
        const DtElement = getElement("[data-table=dt]", this);
        // const BtnNew = getElement("[name=new]", this); // Identificar el botón para crear

        // Start DataTable
        let configDt = {
            processing: true, // Procesar ajax
            serverSide: true, // Mejorar velocidad ajax registros por página
            scrollY: "500px", // Define la altura de desplazamiento para el cuerpo de la tabla
            scrollCollapse: true, // Permite que el contenido colapse dentro del área definida
            fixedHeader: true, // Mantiene el encabezado visible al hacer scroll
        };

        configDt.ajax = {
            url: getData("taxesUrlDt"),
            type: "POST",
            beforeSend: function (request) {
                request.setRequestHeader("X-CSRF-TOKEN", CSRF);
            },
        };

        // Columnas del AJAX
        configDt.columns = [
            { data: "DT_RowIndex", width: "3%", className: "text-center" },
            { data: "description" },
            { data: "type", width: "7%", className: "text-center" },
            { data: "tax", width: "5%", className: "text-center" },
            {
                data: "category",
                width: "5%",
                className: "text-center",
            },
            { data: "sales", width: "5%", className: "text-center" },
            { data: "purchases", width: "5%", className: "text-center" },
            { data: "surcharge", width: "5%", className: "text-center" },
            { data: "ac_surcharge", width: "5%", className: "text-center" },
            {
                data: "buttons",
                width: "5%",
                className: "text-center",
                orderable: false,
            },
        ];

        const DtCompanies = new Dt(configDt);
        DtCompanies.dataTable(DtElement);
        // End DataTable

        this.addEventListener("click", (e) => {
            const BtnNewTax = e.target.closest("[name=btnNewTax]");
            const BtnEditTax = e.target.closest("[name=btnEditTax]");

            // Agregar Banco
            if (BtnNewTax) {
                TaxModal.create(
                    getData(BtnNewTax, "data-bs-target"),
                    getData(BtnNewTax, "title"),
                    getData(BtnNewTax, "data-url")
                );
            }

            // Editar Banco
            if (BtnEditTax) {
                TaxModal.edit(
                    getData(BtnEditTax, "data-bs-target"),
                    getData(BtnEditTax, "title"),
                    getData(BtnEditTax, "data-url"),
                    getData(BtnEditTax, "data-data")
                );
            }
        });
    }

    events() {
        document.addEventListener("keydown", (e) => {
            // Identificar cuando se presione la tecla ctrl+a
            if (e.ctrlKey && e.key === "a") {
                e.preventDefault();
                const BtnNew = getElement("[name=btnNewTax]", this);
                // Simular el clic en el botón de nuevo
                BtnNew?.click();
            }
        });
    }
}

window.customElements.define("tax-module", TaxModule, {
    extends: "section",
});
